/* eslint-disable react-hooks/exhaustive-deps */
import { AuthUser, getCurrentUser } from 'aws-amplify/auth';
import React, { createContext, useEffect, useState } from 'react';
import { Subscription } from '../types/Subscription';
import LoadingIcon from '../icons/LoadingIcon';
import { handleSignOut } from '../handlers/signOut';
import useNavigation, { StoreError } from '../hooks/useNavigation';
import userClient from '../utils/apiClients/userClient';
import useAuthToken from '../hooks/useAuthToken';
import { useAppSelector } from '../store/store';
type WhitelistContextType = {
  isWhitelisted: boolean;
  user: AuthUser | null;
  subscription: Subscription | null;
};

export const WhitelistContext = createContext<WhitelistContextType>({} as WhitelistContextType);

export const WhitelistProvider = ({ children }: { children: React.ReactNode }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isWhitelisted, setIsWhitelisted] = useState(false);
  const [user, setUser] = useState<AuthUser | null>(null);
  const { subscription } = useAppSelector(e => e.subscription);
  const { isAuthenticated, isLoading: tokenLoading } = useAuthToken();
  const navigation = useNavigation();

  const initializeApp = async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      if (!isAuthenticated) return;
      const { data }: { data: { user: object } } = await userClient.post('/login', {});
      const user = await getCurrentUser();
      setUser(user);
      if (!data.user) setIsWhitelisted(true);
    } catch (error) {
      StoreError('An error occured when we initializeApp and call getCurrentUser and login api /login', error);
      handleSignOut();
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    initializeApp();
  }, []);

  if (isLoading || tokenLoading) {
    return (
      <div className="grid place-items-center h-screen w-full">
        <div>
          <LoadingIcon />
          <p className="font-inter text-semibold mt-4">Validating Access...</p>
        </div>
      </div>
    );
  }

  if (isWhitelisted) {
    return (
      <div className="grid place-items-center h-screen w-full">
        <div className="flex flex-col items-center">
          <LoadingIcon width={180} />
          <p className="font-inter text-semibold mt-4">Thank you for your interest!</p>
          <p className="font-inter text-semibold mt-4">You are on waitlist. Please wait, while we get you onboard!</p>
        </div>
      </div>
    );
  }

  if (navigation) {
    return navigation;
  }

  return <WhitelistContext.Provider value={{ isWhitelisted, user, subscription }}>{children}</WhitelistContext.Provider>;
};
